import { render, staticRenderFns } from "./messageCenter.vue?vue&type=template&id=580ec91a&scoped=true"
import script from "./messageCenter.vue?vue&type=script&lang=js"
export * from "./messageCenter.vue?vue&type=script&lang=js"
import style0 from "./messageCenter.vue?vue&type=style&index=0&id=580ec91a&prod&scoped=true&lang=css"
import style1 from "./messageCenter.vue?vue&type=style&index=1&id=580ec91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ec91a",
  null
  
)

export default component.exports